/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';

export default class extends Component{
    render() {
        return (
            <div className={`separador ${this.props.region}`}>
                <div className="flecha">
                    <img src={`/img/flecha-${this.props.region}.png`} alt=""/>
                </div>
                <div className="texto">{this.props.texto}</div>
                <div className="linea"><hr/></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Separador.js